import React, { lazy, Suspense } from 'react';

import { Head as SEO, Team } from '@landing/components';
import Header from 'components/Header';
import { anchorLinks } from 'define/anchorLinks';
import Intro from 'components/Intro';
import EventProgram from 'components/EventProgram';
import Location from 'components/Location';
import ContactUs from 'components/ContactUs';
import Footer from 'components/Footer';
import CookiesPolicy from 'components/CookiesPolicy/CookiesPolicy';
import { useIsSsr } from 'utils/hooks';
import {
  logoUrl,
  meetupStartTime,
  meetupDate,
  timeZone,
  initialCoordinates,
  markerSettings,
} from 'define/warsaw/constants';

import data from './data.json';

const RequestConsultation = lazy(() =>
  import('components/Modals').then(({ RequestConsultation }) => ({
    default: RequestConsultation,
  })),
);

const SuccessModal = lazy(() =>
  import('components/Modals').then(({ SuccessModal }) => ({
    default: SuccessModal,
  })),
);

const ErrorModal = lazy(() =>
  import('components/Modals').then(({ ErrorModal }) => ({
    default: ErrorModal,
  })),
);

const ConsentModal = lazy(() =>
  import('components/Modals').then(({ ConsentModal }) => ({
    default: ConsentModal,
  })),
);

export default function EuropeDigitalSovereigntyWarsaw() {
  const isSsr = useIsSsr();

  return (
    <>
      <Header logoUrl={logoUrl} anchorLinks={anchorLinks} meetupDate={meetupDate} />
      <Intro
        {...data.intro}
        meetupStartTime={meetupStartTime}
        meetupDate={meetupDate}
        timeZone={timeZone}
      />
      <Team {...data.team} />
      <EventProgram
        {...data.eventProgram}
        meetupStartTime={meetupStartTime}
        meetupDate={meetupDate}
        timeZone={timeZone}
      />
      <Location
        {...data.location}
        meetupStartTime={meetupStartTime}
        meetupDate={meetupDate}
        timeZone={timeZone}
        initialCoordinates={initialCoordinates}
        markerSettings={markerSettings}
      />
      <ContactUs {...data.contactUs} meetupDate={meetupDate} />
      <Footer anchorLinks={anchorLinks} />
      <CookiesPolicy />
      {!isSsr && (
        <Suspense fallback={null}>
          <RequestConsultation />
          <SuccessModal />
          <ErrorModal />
          <ConsentModal />
        </Suspense>
      )}
    </>
  );
}

export const Head = () => <SEO {...data.head} />;
